import * as React from 'react'
import { Skeleton as AntSkeleton } from 'antd'

export default function SkeletonInput(props) {
  const { loading, children, ...restprops } = props
  if (typeof loading === 'boolean') return loading ? <AntSkeleton.Input {...restprops} /> : children

  return <AntSkeleton.Input {...restprops} />
}
